import React from 'react';

import TreeViewList from './treeViewList';

const SearchSelectBox = ({ specialClass, options, defaultValue, keyForSelect, onSelectFunction, resultSearch, readOnly, forceForSearch }) => {
	const setSlectedValue = ({ isEqual, selectedNode, typedValue }) => {
		onSelectFunction(keyForSelect, isEqual, selectedNode, typedValue, resultSearch);
	};
	return (
		<div
			className={`select_tree_search ${specialClass} ${
				options.children.length !== 0 &&
				options.children[0] !== undefined &&
				options.children[0].specialListClass
			}`}
		>
			<TreeViewList
				{...{
					options,
					defaultValue,
					setSlectedValue,
					resultSearch,
					readOnly,
					forceForSearch
				}}
			/>
		</div>
	);
};

export default SearchSelectBox;
